export default __webpack_public_path__ + "static/media/DMMY.a05dad96.png";